import { Box } from "@mui/material";
import React, { ReactNode } from "react";

interface DrawerHeaderProps {
    children?: ReactNode
}

export const DrawerHeader = ({ children }: DrawerHeaderProps) => {
    return (
        <Box sx={(theme) => ({
            height: "66px",
            background: theme.palette.action.hover,
            display: "flex",
            alignItems: "center",
            borderBottom: "1px solid",
            borderColor: theme.palette.divider,
            padding: "24px",
        })}>
            {children}
        </Box>
    );
};
